// @flow
import { FetchApi } from "../model/fetch";
import { LoginService } from "./login-service";
import { RegisterService } from "./register-service";
import { ValidationService } from "./validation-service";
import { ResetPasswordService } from "./reset-password-service";
import { PostcodeService } from "./postcode-service";

export class ServiceManager {
    loginService: LoginService;
    registerService: RegisterService;
    validationService: ValidationService;
    resetPasswordService: ResetPasswordService;
    postcodeService: PostcodeService;
    constructor(
        fetchApi: FetchApi,
        options: { basepath: string }
    ) {
        this.loginService = new LoginService(fetchApi, options);
        this.registerService = new RegisterService(fetchApi, options);
        this.validationService = new ValidationService(fetchApi, options);
        this.resetPasswordService = new ResetPasswordService(fetchApi, options);
        this.postcodeService = new PostcodeService(fetchApi, options);
    }
}
